<template>
  <div class="w100 pt20 pl20 pr20 bg-w" style="min-height: 650px;" v-loading="loading">
    <div class="w100 mb20 cl-f">
      <span class="font-16">服务管理中心</span>
      <span class="ml5 grey" v-if="list.length">（共计 {{ list.length }} 个服务）</span>
      <div class="flex-box fr">
        <el-input class="mr10" placeholder="查询" size="mini" prefix-icon="el-icon-search" v-model="searchText" @keyup.enter.native="initPage" clearable></el-input>
        <el-button type="primary" size="mini" @click="initPage">查询</el-button>
      </div>
    </div>

    <el-row class="w100 mb20 pb20" :gutter="20" style="margin: 0">
      <el-col :span="6" v-for="(val, key) in list" :key="key">
        <div class="po-r w100 bg-ww of-h cu-p search-list" @click="goPage(val)">
          <p class="po-r w100 bor-b font-14 pl10 title grey ellipsis">{{ val.serveTitle }}</p>
          <div class="po-r w100 search-list-main">
            <img :src="!val.serveImage ? baseUrl + 'images/icon-app.png' : val.serveImage">
            <p class="w100 ellipsis font-14">{{ val.serveName }}</p>
            <div class="w100 star">
              <el-rate :value="val.appraise / 2" disabled allow-half></el-rate>
            </div>
            <p class="w100 font-12 grey ellipsis">{{ !val.favoriteCount ? 0 : val.favoriteCount }}人收藏</p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "OfficeBiz",
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      searchText: "",
      list: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.initPage();
  },
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "serve/manager/query",
          this.$qs.stringify({
            serveKey: this.searchText,
            pageNum: 1,
            pageSize: 99999
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resCode == 0) {
            this.list = data.resData.list;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "页面请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    initPage() {
      this.fetchList();
    },
    goPage(item) {
      // console.log(item);
      this.$router.push({
        name: "officeBizEdit",
        params: {
          id: item.id,
          serveType: item.serveType
        }
      });
    }
  },
  watch: {}
};
</script>

<style scoped>
.search-list {
  margin: 8px 0;
  height: 128px;
  border-radius: 8px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12);
}

.search-list .title {
  padding-right: 30px;
  height: 30px;
  line-height: 30px;
}

.search-list .title::after {
  content: "";
  display: block;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 14px;
  height: 14px;
  background: #eeeeee;
  border-radius: 50%;
}

.search-list-main {
  padding: 20px 10px 10px 80px;
}

.search-list-main img {
  position: absolute;
  width: 54px;
  height: 54px;
  left: 14px;
  top: 22px;
}
</style>

<style>
.search-list-main .star i {
  margin-right: 2px;
  font-size: 14px;
}
</style>
